import React, { useEffect } from 'react';
import classNames from 'classnames';

import { manageSubscriptions } from '../../lib/util/TradingHelpers';

import { LatestNews } from '../../components';
import { useIsMobile } from '../../hooks';
import EpicMovers from '../EpicMovers/EpicMovers';
import HotGappers from '../HotGappers/HotGappers';
import LongTermInvestments from '../LongTermInvestments/LongTermInvestments';
import MarketIndexes from '../MarketIndexes/MarketIndexes';
import PopularGroups from '../PopularGroups/PopularGroups';
import UpcomingEarnings from '../UpcomingEarnings/UpcomingEarnings';
import Week52GainersAndLosers from '../Week52GainersAndLosers/Week52GainersAndLosers';

import styles from './Discover.module.scss';

const Discover = () => {
  const isMobile = useIsMobile();

  useEffect(() => {
    manageSubscriptions('discover', null, true, true);
  }, []);

  return (
    <div className={isMobile ? classNames(styles.wrapperLayout, styles.noMargin) : styles.wrapperLayout}>
      <div className={styles.wrapperFirstSection}>
        <MarketIndexes />
        <HotGappers />
        <EpicMovers />
        <Week52GainersAndLosers />
        <PopularGroups />
        <div className={isMobile ? styles.longTermInvestmentsWrapper : undefined}>
          <LongTermInvestments />
        </div>
        {/* TODO: Enable New on the Market feature when the backend team fiexes the konown issues */}
      </div>
      <div className={styles.wrapperSecondSection}>
        <UpcomingEarnings />
        <div className={styles.news}>
          <LatestNews />
        </div>
      </div>
    </div>
  );
};

export default Discover;
